<script setup lang="ts">
import purpose from "@/assets/img/icon/purpose.svg";
import inspiration from "@/assets/img/icon/inspiration.svg";
import action from "@/assets/img/icon/action.svg";
import results from "@/assets/img/icon/results.svg";
import content from "@/assets/img/icon/content.svg";
import activeLearning from "@/assets/img/icon/active-learning.svg";

const features = [
  {
    icon: purpose,
    title: "Formación con Propósito",
    description:
      "Diseñamos experiencias que transforman la forma de pensar, trabajar y liderar.<br/>No son solo sesiones: son palancas de cambio.",
  },
  {
    icon: inspiration,
    title: "Expertos que inspiran",
    description:
      "Nuestros formadores no solo enseñan, aplican lo que enseñan.<br/>Profesionales con experiencia real en empresa que conectan con tu equipo.",
  },
  {
    icon: action,
    title: "Aplicación inmediata",
    description:
      "Todo lo aprendido se puede poner en práctica desde el primer día.<br/>Porque el conocimiento sin acción, no transforma.",
  },
  {
    icon: results,
    title: "Resultados que se miden",
    description:
      "No trabajamos con ideas abstractas: cada taller incluye objetivos claros y seguimiento del impacto en el equipo.",
  },
  {
    icon: content,
    title: "Contenido actualizado",
    description:
      "Explore a diverse range of courses tailored to your interests and career goals.",
  },
  {
    icon: activeLearning,
    title: "Aprendizaje activo y colaborativo",
    description:
      "Explore a diverse range of courses tailored to your interests and career goals.",
  },
];
</script>

<template>
  <section class="container mx-auto mb-16" id="features">
    <div class="main max-w-7xl mx-auto">
      <div class="max-w-6xl mx-auto text-center mb-12">
        <span
          class="text-sm text-blue-600 font-semibold uppercase tracking-wide topButton mx-auto font-poppins text-blue"
          >Descubre</span
        >
        <h2
          class="text-xl md:text-4xl font-bold text-gray-900 mt-2 font-poppins"
        >
          ¿Por qué elegir nuestros talleres?
        </h2>
      </div>

      <div class="grid gap-6 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 p-6">
        <HomeSectionsFeatureCard
          v-for="(feature, index) in features"
          :key="index"
          :icon="feature.icon"
          :title="feature.title"
          :description="feature.description"
        />
      </div>
    </div>
  </section>
</template>
<style scoped>
.topButton {
  border-radius: 24px;
  background: var(--Subtle-Blue, #e8f6ff);
  display: flex;
  padding: 8px 16px;
  justify-content: center;
  align-items: flex-start;
  gap: 10px;
  width: fit-content;
}
</style>
